import { endpoint } from '@/services/api';

import {
  FieldsMappingResponseSchema,
  TextractDocumentPathSchema,
} from '@/domain/textract/schemas';

export const textractApi = {
  getFieldsMapping: endpoint({
    method: 'GET',
    url: (p: { documentID: string }) => `tables_data/fields/${p.documentID}`,
    path: TextractDocumentPathSchema,
    response: FieldsMappingResponseSchema,
  }),
};
